export const AUTOMATION_TESTS_PORT = 3100;

export const TEST_ENV = 'test';
export const PRODUCTION_ENV = 'production';

export const RELEASE_GA = 'GA';
export const RELEASE_RC = 'RC';
